// Expand/collapse behaviour for the sidebar section navigation
// (macros/section-nav.html). On mobile the nav renders as an "In this
// section" disclosure; on desktop the summary is hidden by CSS and the
// panel is always visible.

// Matches the `to($bp-medium)` breakpoint in the SCSS (1024px - 1, in ems).
const MOBILE_QUERY = '(max-width: 63.9375em)';

export default function initSectionNav() {
	initDisclosure();
	initToggles();
}

function initDisclosure() {
	const $summary = document.querySelector('[data-section-nav-summary]');
	if (!$summary) return;

	const $panel = document.getElementById($summary.getAttribute('aria-controls'));
	if (!$panel) return;

	const mq = window.matchMedia(MOBILE_QUERY);

	// On mobile the panel starts collapsed until the summary is activated;
	// on desktop it is always shown.
	const apply = () => {
		const isOpen = $summary.getAttribute('aria-expanded') === 'true';
		$panel.hidden = mq.matches && !isOpen;
	};

	apply();
	mq.addEventListener('change', apply);

	$summary.addEventListener('click', () => {
		const isOpen = $summary.getAttribute('aria-expanded') === 'true';
		$summary.setAttribute('aria-expanded', String(!isOpen));
		apply();
	});
}

function initToggles() {
	document.querySelectorAll('[data-section-nav-toggle]').forEach($toggle => {
		const $target = document.getElementById(
			$toggle.getAttribute('aria-controls')
		);
		if (!$target) return;

		$toggle.addEventListener('click', () => {
			const isOpen = $toggle.getAttribute('aria-expanded') === 'true';
			$toggle.setAttribute('aria-expanded', String(!isOpen));
			$target.hidden = isOpen;
			$toggle.closest('.section-nav--item').classList.toggle('is-open', !isOpen);
		});
	});
}
